export enum MOODS {
  POSITIVE = 'positive',
  NEUTRAL = 'neutral',
  NEGATIVE = 'negative',
}

export enum MOOD_STATES {
  DEFAULT = 'default',
  SELECTED = 'selected',
  DISABLED = 'disabled',
}

export const MOOD_VALUES: Record<MOODS, number> = {
  [MOODS.NEGATIVE]: 0,
  [MOODS.NEUTRAL]: 1,
  [MOODS.POSITIVE]: 2,
} as const;
